import { inject, reactive, ref, provide, computed} from 'vue';

import Card from '@/components/content/views/card/card.vue';
import FormattingService from '@/services/formatting.service';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@/components/content/views/tooltip/tooltip.vue';
import SkeletonLoader from '@/components/content/views/skeleton-loader/skeleton-loader.vue';
import item from '../../blocks/collection/gallery/item/item';

library.add(faInfo);

export default {
  name: 'Toolkit',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    FontAwesomeIcon,
    Card,
    Tooltip,
    SkeletonLoader,
  },
  setup(props) {
    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      imageUrl: computed(() => {
        if(!state.item.images) return '';
        if(state.item.images['480w']) return state.item.images['480w'];
        if(state.item.images['362w']) return state.item.images['362w'];
        if(state.item.images['320w']) return state.item.images['320w'];
        return state.item.images.full;
      }),
      isNew: computed(() => {
        let now = new Date();
        let published = new Date(state.item.dates.created);
        let diff = now.getTime() - published.getTime();
        let dayDiff = diff/(1000 * 60 * 60 * 24);
        return dayDiff >= 30 ? false : true;
      }),
      hasAccess: computed(() => {
        let access = false;
        if(state.member && state.item) {
          for(let i = 0; i < state.member.subscriptions.length; i++) {
            for(let k = 0; k < state.member.subscriptions[i].products.length; k++) {
              if(state.item.tiers.includes(state.member.subscriptions[i].products[k].tier) && (state.member.subscriptions[i].status === 'active' || state.member.subscriptions[i].status === 'past_due')) {
                access = true;
                break;
              }
            }
          }
        }
        return access;
      }),
    });

    return {
      state,
      FormattingService,
    }
  },
  methods: {
    toggleModal(item) {
      this.$emit('toggleModal', item);
    }
  }
}
